import React from "react";
import { Link, useRouteMatch } from "react-router-dom";

export function ContactIdLinkCell({ contactId }: { contactId: number }) {
  const { url } = useRouteMatch();

  return (
    <Link
      className="tw-w-full tw-text-inherit hover:tw-underline"
      to={`${url}/${contactId}`}
    >
      {contactId}
    </Link>
  );
}
